import clsx from 'clsx'

const SIZE_CLASSES = {
  sm: 'text-base',
  md: 'text-xl',
  lg: 'text-2xl',
  xl: 'text-3xl'
}

function Wordmark({ size = 'md', inverse = false, className = '' }) {
  return (
    <span
      className={clsx(
        'font-logo font-bold leading-none tracking-normal',
        SIZE_CLASSES[size] || SIZE_CLASSES.md,
        className
      )}
    >
      <span>x3</span>
      <span className={inverse ? 'text-[#A78BFA]' : 'text-[#4F46E5] dark:text-[#A78BFA]'}>
        Algo
      </span>
    </span>
  )
}

export default Wordmark
